import { render } from "./delete-modal.vue?vue&type=template&id=a911eff8&ts=true"
import script from "./delete-modal.vue?vue&type=script&lang=ts"
export * from "./delete-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__